import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, mergeMap, tap } from 'rxjs/operators';

import { AuthState, AuthStore } from '@store';

@Injectable()
export class RsaAuthGuardService {
  constructor(private authStore: AuthStore, private router: Router) {}

  canActivate(): Observable<boolean> {
    return this.checkAuth();
  }

  private checkAuth(): Observable<boolean> {
    return this.authStore.state$.pipe(
      filter((state: AuthState) => {
        if (!state.authorized && !state.authorizing && !state.authenticating) {
          this.router.navigate(['/home']);
        }

        return state.authorized;
      }),
      mergeMap(() => this.authStore.isRsaUser()),
      tap((isRsaUser: boolean) => {
        if (!isRsaUser) {
          this.router.navigate(['/installations']);
        }
      })
    );
  }
}
